import { Helper } from '../../../../../../classes/helper'
import { cover } from '../../../../../../utility/constant/helper.constant'
import { useMontage } from '../../../../../../context/montage.context'
import { useThree } from '@react-three/fiber'
import { useHelper } from '@react-three/drei'
import { RectAreaLightHelper } from 'three/examples/jsm/helpers/RectAreaLightHelper'
import { useRef } from 'react'

export const WindowsTopBarOuter = (): JSX.Element => {
  const { measure, roof, ledSpots, night } = useMontage()
  const ref = useRef()
  // useHelper(ref, RectAreaLightHelper)

  const positionOuter = measure.userWidth! / 2 - cover.bar.width / 2
  return (
    <>
      {night?.night && (
        <group
          rotation={[Helper.convertAngleToRadiant(measure.userAngle!), 0, 0]}
        >
          <rectAreaLight
            ref={ref as any}
            position={[
              0,
              Helper.convertToMeter(measure.userHeight),
              Helper.convertToMeter(measure.userDepth) / 2,
            ]}
            width={(Helper.convertToMeter(measure.userWidth) * 2) / 3}
            height={(Helper.convertToMeter(measure.userDepth) * 2) / 3}
            color="#ff7e38"
            intensity={2}
            rotation={[-Math.PI / 2, 0, 0]}
          ></rectAreaLight>
        </group>
      )}

      {[...Array(2)].map((_, index) => {
        return (
          <mesh
            key={index}
            position={[
              Helper.convertToMeter(positionOuter * (index ? -1 : 1)),
              Helper.convertToMeter(measure.userHeight!),
              Helper.convertToMeter(measure.userDepth! / 2),
            ]}
            castShadow={cover.terraceCover.castShadow}
            rotation={[Helper.convertAngleToRadiant(measure.userAngle!), 0, 0]}
          >
            <boxGeometry
              args={[
                Helper.convertToMeter(cover.bar.width),
                Helper.convertToMeter(cover.bar.height),
                Helper.convertToMeter(
                  measure.userDepth! +
                    Helper.extendTopElements(measure.userAngle)
                ),
              ]}
            />
            <meshPhysicalMaterial color={roof.userColor} />
          </mesh>
        )
      })}
    </>
  )
}
